"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const h = React.createElement;
const blockClass = (0, nano_theme_1.drule)({
    h: '2px',
    pos: 'relative',
    trs: 'width 0.3s',
    transitionTimingFunction: 'cubic-bezier(.08,.91,.26,1)',
});
const glowClass = (0, nano_theme_1.drule)({
    pos: 'absolute',
    right: 0,
    w: '100px',
    h: '2px',
    transform: 'rotate(3deg) translate(0px, -4px)',
});
const Progress = ({ value = 0, glow, style }) => {
    const styles = (0, context_1.useStyles)();
    const glowColor = styles.col.get('success', 'solid-1');
    return h('div', {
        className: blockClass({ bg: styles.col.get('success', 'el-3') }),
        style: {
            ...style,
            width: Math.min(1, Math.max(0, value)) * 100 + '%',
        },
    }, !!glow &&
        h('div', {
            className: glowClass({
                boxShadow: `0 0 10px ${glowColor}, 0 0 5px ${glowColor}, 0 0 5px ${glowColor}`,
            }),
        }));
};
exports.Progress = Progress;
